import React from 'react'
import {IconButton} from '@mui/material';
import { styled } from '@mui/system';

export const ProButton = styled(IconButton)(() => ({ 
   position:'absolute',
   width: '14px',
   height: '14px',
   right:'6px',
   top: '6px',
}));


export const ProIconButton =  (props) => {
	let productId = props.id;
	let size = props.size || '1.7vw';
	// When in collection mode, position on the left to avoid overlap with delete icon
	let right = props.moveToLeft ? 'auto' : (props.right || '6px');
	let left = props.moveToLeft ? '6px' : 'auto';

	return (
		<React.Fragment>
			<ProButton id={"Pro_"+ productId} sx={{ right: right, left: left }}>
				<div style={{position: 'absolute', zIndex:10, width: size, height: size, top:1, right: props.moveToLeft ? 'auto' : 1, left: props.moveToLeft ? 1 : 'auto', background: 'url(/images/icons/proFinalIcon.png)', backgroundSize:'contain',backgroundRepeat: 'no-repeat' }} />
			</ProButton>
		</React.Fragment>
	);	
}